import { IContextualMenuItem, IContextualMenuProps } from '@fluentui/react';
import { TooltipItem } from '@v2/components/base/ButtonTooltip';
import DefaultButtonEx from '@v2/components/base/DefaultButtonEx';
import React from 'react';
import office from 'src/services/office';

export interface MultiButtonItem extends Omit<IContextualMenuItem, 'text'> {
  key: string;
  text: string;
  tooltip?: string;
  subMenuProps?: IContextualMenuProps;
}

export interface MultiButtonProps {
  items?: MultiButtonItem[];
  onClick: (event: any, item: IContextualMenuItem | undefined) => void;
  primary?: boolean;
  disabled?: boolean;
  menuProps?: IContextualMenuProps;
  [key: string]: any;
}

const MultiButton: React.FC<MultiButtonProps> = ({
  items = [],
  onClick,
  primary,
  disabled,
  menuProps: initialMenuProps = {},
  ...restProps
}) => {
  // Focus zone width fix. Actual min-width is 180px, so it's rendered bigger than our button
  const focusZoneProps = { style: { minWidth: '140px' } };
  const [item = {} as MultiButtonItem, ...restItems] = items;
  const split = !!restItems.length;

  const tooltip: TooltipItem[] = items
    .filter(x => !!x.tooltip)
    .map(x => ({ header: x.text, text: x.tooltip || '' }));

  const addOnClick = ({ items, ...rest }: IContextualMenuProps): IContextualMenuProps => ({
    ...rest,
    focusZoneProps,
    onItemClick: onClick,
    items: items?.map(({ subMenuProps, ...restItem }) => ({
      ...restItem,
      subMenuProps: subMenuProps ? addOnClick(subMenuProps) : undefined,
    })) || []
  });

  const menuProps = addOnClick({
    isBeakVisible: false,
    useTargetAsMinWidth: true,
    useTargetWidth: true,
    items: !office.isPlatformiOS ? restItems : items, // WORKARROUND: FluentUI under mobile is not support main action,
    ...initialMenuProps,
  });

  return (
    <DefaultButtonEx
      text={item.text}
      split={split}
      primary={primary}
      disabled={disabled}
      tooltip={tooltip}
      splitButtonAriaLabel="Other options"
      aria-roledescription="split button"
      onClick={(event) => onClick(event, item)}
      menuProps={split ? menuProps : undefined}
      {...restProps}
    />
  );
};

export default MultiButton;
